import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import BarcodeGeneratorPage from './pages/BarcodeGeneratorPage';
import SerialConsolePage from './pages/SerialConsolePage';
import ProfilesPage from './pages/ProfilesPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import FirmwarePage from './pages/FirmwarePage';
import FirmwareBuilderPage from './pages/FirmwareBuilderPage';
import AdminUsersPage from './pages/AdminUsersPage';
import FilesPage from './pages/FilesPage';
import AiAssistantPage from './pages/AiAssistantPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f1419]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-brand-500/30 border-t-brand-500 rounded-full animate-spin" />
          <p className="text-gray-600 text-sm font-mono">Loading SophistiScan...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="barcode" element={<BarcodeGeneratorPage />} />
            <Route path="serial" element={<SerialConsolePage />} />
            <Route path="profiles" element={<ProfilesPage />} />
            <Route path="history" element={<HistoryPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="firmware" element={<FirmwarePage />} />
            <Route path="firmware-builder" element={<FirmwareBuilderPage />} />
            <Route path="files" element={<FilesPage />} />
            <Route path="admin/users" element={<AdminUsersPage />} />
            <Route path="ai" element={<AiAssistantPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
